<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SRkgxM/CoverDesign.jpg?1684514749074" alt="This image is the cover for the book Jupiter, States of Love"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jupiter, States of Love
      </h1>
      <p class="bookDescription body article font2">
        <p>For fourteen-year-old Jacob Thomas, a Christian and the smartest kid in class, Bobby Versailles is completely out of reach. Jacob wishes a girl named Allie loved him because he still doesn’t get that he’s gay, but he always keeps his eyes peeled at school, hoping to catch a glimpse of Bobby. </p><p>It’s Bobby Versailles’s senior year. Captain of his high school football team, he’s bound to win Homecoming King and hopefully a state championship, but he’s been miserable for years. His fear of somebody finding out he’s gay has brought isolation and loneliness. He has hidden that he’s gay by going on dates with girls now and then, and also by working out and excelling at football—which has also helped teachers look past his learning difficulties. When he first eyes Jacob, it’s possibly love at first sight. Bobby becomes a little obsessed. Jacob has got to be gay, and when Bobby makes a move, both of their worlds turn upside down! </p><p>It’s 1982, and while the Nebraska Cornhuskers are barreling toward a possible NCAA National Football Championship, everyone in a small town two hours away hopes Bobby can lead them to a state championship. Can two teens with vastly different lives find love amidst the fervor of Nebraska football?</p><p><b>States of Love: </b> Stories of romance that span every corner of the United States.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rhett Heath
      </h2>
      
      <p class="authorDescription body article"><P>Rhett Heath lives in the beautiful Rogue Valley of southwestern Oregon. Once an award-winning actor, now an avid theatregoer, he&rsquo;ll travel far and wide to see good theater. He is also an avid reader: he loves reading tales of Valdemar and stories of gay teens in Indiana.</P><P>Rhett works with children and adults who have learning difficulties&mdash;he has learned a technique that helps them learn easily. In addition to having been an English teacher&mdash;both in the States and abroad&mdash;he&rsquo;s worked as a lifeguard, the super of an apartment complex, a forest firefighter, and as a scout for a modeling agency.</P><P>He enjoys a well-run rodeo, well-written TV show or movie, well-thought-out looks on RPDR, a well-hidden fishing hole, and, well, watching a good football game.</P><P>He has no pets. He has no plants. He doesn&rsquo;t enjoy exercise.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1858614c